import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

export default function AppBar() {
  const [company, setCompany] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const inactivityTimer = useRef(null);
  const navigate = useNavigate();

  // --- Oturum zamanlayıcısı (3 dakika inaktifse çıkış yap) ---
  const startInactivityTimer = useCallback(() => {
    if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(() => handleLogout(true), 360000);
  }, []);

  const resetInactivityTimer = useCallback(() => startInactivityTimer(), [startInactivityTimer]);

  // --- Çıkış işlemi ---
  const handleLogout = useCallback(async (auto = false) => {
    try {
      const auth = getAuth();
      await auth.signOut();
    } catch (e) {
      console.error("SignOut error:", e);
    }
    localStorage.removeItem("companyData");
    localStorage.removeItem("loginTimestamp");
    setCompany(null);
    setIsMobileMenuOpen(false);
    if (auto) alert("Oturum süresi doldu. Güvenlik nedeniyle çıkış yapıldı.");
    navigate("/");
  }, [navigate]);

  // --- Kurumsal kullanıcıyı kontrol et ve event listener ekle ---
  useEffect(() => {
    try {
      const savedCompany = localStorage.getItem("companyData");
      if (savedCompany) {
        const parsed = JSON.parse(savedCompany);
        setCompany(parsed);
        startInactivityTimer();
        ["mousemove", "keydown", "click", "scroll"].forEach(ev => window.addEventListener(ev, resetInactivityTimer));
      }
    } catch (err) {
      console.error("Failed to parse companyData:", err);
    }

    return () => {
      if (inactivityTimer.current) clearTimeout(inactivityTimer.current);
      ["mousemove", "keydown", "click", "scroll"].forEach(ev => window.removeEventListener(ev, resetInactivityTimer));
    };
  }, [resetInactivityTimer, startInactivityTimer]);

  const handleLogoClick = () => { navigate("/"); setIsMobileMenuOpen(false); };
  const handleGoDashboard = () => { navigate("/dashboard_corporate"); setIsMobileMenuOpen(false); };
  const isMobile = windowWidth <= 1024;

  useEffect(() => {
    let timeout = null;
    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setWindowWidth(window.innerWidth), 100);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="app-bar">
      <div className="logo-container">
        <h1 className="logo" onClick={handleLogoClick}>TEMELDEN</h1>
      </div>

      {/* Masaüstü görünüm */}
      {!isMobile && (
        <>
          <div className="center-section">
            <nav className="nav">
              <Link to="/" className="link">Anasayfa</Link>
              <Link to="/projects" className="link">Projeler</Link>
              <Link to="/haberler" className="link">Haberler</Link>
              <Link to="/yatirim" className="link">Yatırım</Link>
            </nav>
          </div>

          <div className="right-section">
            {company ? (
              <>
                <span
                  className="auth-link clickable"
                  onClick={handleGoDashboard}
                  title="Kurumsal Panele Git"
                >
                  {company.company_name || "Kurumsal Hesap"}
                </span>
                <button onClick={() => handleLogout(false)} className="ad-button logout-btn">
                  Çıkış Yap
                </button>
              </>
            ) : (
              <>
                <Link to="/login_corporate" className="auth-link">Kurumsal Giriş Yap</Link>
                <Link to="/signup_corporate" className="ad-button">Kurumsal Üye Ol</Link>
              </>
            )}
          </div>
        </>
      )}

      {/* Mobil görünüm */}
      {isMobile && (
        <>
          <div
            className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </div>

          <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
            <nav className="mobile-nav">
              <Link to="/" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Anasayfa</Link>
              <Link to="/projects" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Projeler</Link>
              <Link to="/haberler" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Haberler</Link>
              <Link to="/yatirim" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>Yatırım</Link>
              

              {company ? (
                <>
                  <span className="mobile-link clickable" onClick={handleGoDashboard}>
                    {company.company_name}
                  </span>
                  <button onClick={() => handleLogout(false)} className="mobile-button">
                    Çıkış Yap
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login_corporate" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
                    Kurumsal Giriş Yap
                  </Link>
                  <Link to="/signup_corporate" className="mobile-link" onClick={() => setIsMobileMenuOpen(false)}>
                    Kurumsal Üye Ol
                  </Link>
                </>
              )}
            </nav>
          </div>
        </>
      )}

      <style jsx>{`
        .app-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #FFC107;
          padding: 0 30px;
          height: 80px;
          position: sticky;
          top: 0;
          z-index: 1100;
        }

        .logo-container { flex: 1; }

        .logo {
          font-size: 30px;
          font-weight: bold;
          color: #001E78;
          margin: 0;
          cursor: pointer;
        }

        .center-section { flex: 1; display: flex; justify-content: center; }

        .right-section {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 20px;
        }

        .nav { display: flex; gap: 30px; }

        .link {
          color: #001E78;
          text-decoration: none;
          font-weight: 650;
          font-size: 16px;
          padding: 8px 12px;
          border-radius: 4px;
          transition: background-color 0.2s;
        }

        .link:hover { background-color: rgba(0, 30, 120, 0.1); }

        .auth-link {
          color: #001E78;
          text-decoration: none;
          font-weight: 600;
          padding: 8px 12px;
          border-radius: 4px;
        }

        .clickable { cursor: pointer; transition: color 0.2s; }
        .clickable:hover { color: #0042cc; }

        .ad-button {
          padding: 8px 16px;
          background-color: #001E78;
          color: #FFC107;
          border-radius: 6px;
          text-decoration: none;
          font-weight: 600;
          font-size: 15px;
          transition: all 0.2s;
        }

        .logout-btn { background-color: #d32f2f; color: #fff; }

        .ad-button:hover { transform: translateY(-2px); box-shadow: 0 2px 4px rgba(0,0,0,0.2); }

        @media (max-width: 1024px) {
          .center-section,
          .right-section { display: none !important; }
          .hamburger { display: flex; cursor: pointer; flex-direction: column; justify-content: space-between; width: 25px; height: 20px; }
          .hamburger-line { height: 3px; background-color: #001E78; border-radius: 2px; }
          .app-bar { padding: 0 20px; height: 70px; }
          .logo { font-size: 26px; }
          .mobile-menu { display: none; flex-direction: column; background-color: #FFC107; position: absolute; width: 100%; top: 70px; left: 0; }
          .mobile-menu.open { display: flex; }
          .mobile-nav { display: flex; flex-direction: column; gap: 10px; padding: 15px; }
          .mobile-link, .mobile-button { color: #001E78; text-decoration: none; font-weight: 600; background: none; border: none; cursor: pointer; padding: 10px 0; text-align: left; }
        }
      `}</style>
    </header>
  );
}
